import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { Wishlist } from 'b2b-apps/shop/myAccount/wishlists/api/Wishlist';
import {
  wishlistSendFulfilled,
  wishlistSendRejected,
} from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistSend/actionCreators';
import { WISHLIST_SEND } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistSend/actionTypes';
import { WishlistSendAction } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistSend/types';

function* sendWishlistSaga(
  action: WishlistSendAction,
): Generator<CallEffect | PutEffect, any, any> {
  const { wishlistId, data } = action.payload;

  try {
    yield call(requestApiSaga, Wishlist.sendToSales(wishlistId, data));
    yield put(wishlistSendFulfilled());
  } catch (error) {
    yield put(reportError(action.type, error, action.payload));
    yield put(wishlistSendRejected(parseError(error)));
  }
}

function* wishlistSendSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all(
    [
      takeEvery(WISHLIST_SEND, sendWishlistSaga),
    ],
  );
}

export {
  wishlistSendSaga,
};
